import React, {useCallback, useEffect, useState} from "react";
import {header, Multipartheader} from "../../Components/Url/ApiUrl";
import {Logout} from "../../Components/Actions/Actions";
import swal from "sweetalert";
import axios from "axios";
import EditCompanyHead from "./EditCompanyHead";
import {useTranslation} from "react-i18next";

const CompanyHead = ({user}) => {
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});
    const [showModal, setShowModal] = useState(false);

    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/companyhead`, {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyHeadData = await response.json();
            setData(companyHeadData);
        } catch (error) {
            console.error('CompanyHead fetch xatosi:', error);
            swal(t('error'), error.message || t('translation:unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const toggleEditMode = () => {
        setFormData(data);
        setShowModal(true);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }
    const handleSave = async () => {
        try {
            let form = new FormData();
            for (const key in formData) {
                form.append(key, formData[key]);
            }
            const res = await axios
                .post(
                    process.env.REACT_APP_API_ENDPOINT + '/company/companyhead',
                    form,
                    {
                        headers:Multipartheader
                    });
            if (!res.data || !res.data?.success) {
                const message = res.data?.message;
                let firstError = t('translation:saving_error');

                if (message && typeof message === 'object') {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                }

                swal(t('error'), firstError, "error");
                throw new Error(firstError);
            }
            setShowModal(false);
            handleFetch();
        } catch (error) {
            const message = error?.message;
            let firstError = t('saving_error');

            if (message && typeof message === 'object') {
                const firstKey = Object.keys(message)[0];
                if (firstKey && Array.isArray(message[firstKey])) {
                    firstError = message[firstKey][0];
                }
            }else{
                firstError = message
            }
            swal(t('error'), firstError || t('unknown_error'), "error");
        }
    }

    const handleCancel = () => {
        setShowModal(false);
    }

    if (loading) {
        return <div className="loading-spinner">{t('loading')}</div>;
    }

    if (!data) {
        return <div>{t('translation:error_occured')}</div>;
    }
    return (
        <div className="company-head-view">
            <div className="d-flex pb-3">
                <h3 className="m-0 me-2">{t('company_head_info')}</h3>
                {Boolean(user.can_update) && (
                    <button
                        className="btn btn-rounded btn-outline-primary p-0"
                        style={{width: "32px", height: "32px"}}
                        onClick={toggleEditMode}
                    >
                        <i className="bi bi-pencil-fill"></i>
                    </button>
                )}
            </div>
            {
                user.can_update ?
                    <EditCompanyHead
                        show={showModal}
                        handleClose={handleCancel}
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                        handleSave={handleSave}
                    />
                    : ''
            }

            <table id="w0" className="table table-striped table-bordered detail-view">
                <tbody>
                <tr>
                    <th style={{width:"300px"}}>{t('head_fio')}</th>
                    <td>{data.fio}</td>
                </tr>
                <tr>
                    <th>{t('head_phone')}</th>
                    <td>{data.phone}</td>
                </tr>
                <tr>
                    <th>{t('head_email')}</th>
                    <td>{data.email}</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}
export default CompanyHead;